export const API_METHODS = {
  GET: "get",
  POST: "post",
  PUT: "put",
  DELETE: "delete",
};

export const DEFAULT_DATE_FORMAT = ["DD-MM-YYYY"];
export const BLANK_VALUE = "__";
export const EMPTY_VALUE = "";
export const PAN_NUMBER = "AABFL2648C";
export const GST_NUMBER = "27AABFL2648C1ZM";
export const PUBLICATION_SIGNATURE_TEMPLATE = "For Luktuke Publicity";
export const PUBLICATION_SIGNATURE_AUTHORITY = "Partner / Manager";
export const FIRM_NAME = "Luktuke Publicity";
export const PDF_LEFT_MARGIN = 40;
export const PDF_RIGHT_MARGIN = 20;
export const PDF_ALL_MARGIN = 5;

export const BANK_DETAILS = {
  bank: "IDBI Bank",
  accNo: "0634651000010043",
  ifsc: "IBKL0000634",
  branch: "Khari Corner",
};

export const DATE_WISE_PRINTING_OPTIONS = [
  { key: "releaseOrder", value: "Release Order" },
  { key: "classifiedReleaseOrder", value: "Classified Release Order" },
  { key: "creditNote", value: "Credit Note" },
  { key: "debitNote", value: "Debit Note" },
  { key: "partyBill", value: "Party Bill" },
  { key: "classifiedPartyBill", value: "Classified Party Bill" },
  { key: "receipt", value: "Receipt" },
  { key: "paymentVoucher", value: "Billwise Payment" },
  { key: "onAccount", value: "On Account Payment" }
];

export const REPORT_TYPES = [
  { key: "releaseOrderRegister", value: "Release Order Register" },
  { key: "classifiedReleaseOrderRegister", value: "Classified Release Order Register" },
  { key: "outstandingBalance", value: "Outstanding Balance" },
  { key: "accountLedger", value: "A/C Ledger" },
  { key: "partywiseRO", value: "Partywise Release Order and Bills" },
  { key: "partywiseTDS", value: "Partywise Total TDS List" },
  { key: "TDSList", value: "Periodwise Total TDS List" },
  { key: "partyBillsGST", value: "Party Bills List(GST)" },
  { key: "GSTList", value: "Periodwise GST Report" },
  { key: "publicationBillGST", value: "Company Bill GST Report" },
  { key: "receiptPending", value: "Periodwise Billwise Receipt Pending" },
  { key: "accountwiseRO", value: "Accountwise Relese Order" }
];

export const ACCOUNT_TYPE = [
  {
    key: "D",
    value: "Debtor",
  },
  {
    key: "C",
    value: "Creditor",
  },
  {
    key: "B",
    value: "Bank",
  },
  {
    key: "G",
    value: "General",
  },
  {
    key: "S",
    value: "Sale",
  },
  {
    key: "P",
    value: "Purchase",
  },
];
